import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { useLocalStorage } from 'react-use';

import { NovaAlert } from './nova-alert';

export const WTW_PHI_DISCLAIMER_FEATURE_FLAG = 'nova-wtw-phi-disclaimer';
export const WTW_PHI_DISCLAIMER_ACKNOWLEDGEMENT_KEY = 'nova-wtw-phi-disclaimer-acknowledged';
export const WTW_PHI_DISCLAIMER_VERSION = 'v1';

interface WtwPhiDisclaimerAlertProps {
  isWtwColleague: boolean;
}

export function WtwPhiDisclaimerAlert({ isWtwColleague }: WtwPhiDisclaimerAlertProps) {
  const isEnabled = useFeatureFlag(WTW_PHI_DISCLAIMER_FEATURE_FLAG, false);
  const [localStorageVersion, setLocalStorageVersion] = useLocalStorage<string>(
    WTW_PHI_DISCLAIMER_ACKNOWLEDGEMENT_KEY,
    undefined,
    { raw: true },
  );
  const isAcknowledged = localStorageVersion === WTW_PHI_DISCLAIMER_VERSION;

  if (!isEnabled || !isWtwColleague || isAcknowledged) {
    return null;
  }

  const handleDismiss = () => {
    setLocalStorageVersion(WTW_PHI_DISCLAIMER_VERSION);
  };

  return (
    <div
      data-testid="wtw-phi-disclaimer-alert"
      className="absolute top-4 left-1/2 z-20 max-w-[calc(100%-2rem)] -translate-x-1/2"
    >
      <NovaAlert
        variant="info"
        label="Important:"
        message="please do not enter PHI into Nova at this time"
        onDismiss={handleDismiss}
        dismissButtonClassName="text-[#2f2f2f] opacity-40"
        dismissIconClassName="size-[13px]"
        className="gap-3.5 px-4 py-2.5 leading-5 font-normal shadow-[0_3px_12px_0_rgba(0,0,0,0.13)]"
      />
    </div>
  );
}
